module.exports = __webpack_public_path__ + "static/media/12_sognolucido.0d90b326.jpg";